import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { useEffect, useState } from "react";
import api from "./services/api";
import {
  Table,
  Spinner,
  Alert,
  Row,
  Col,
  Card,
  Modal,
  Button,
} from "react-bootstrap";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

function App() {
  const [data, setData] = useState([]);
  const [compras, setCompras] = useState([]);
  const [todosKeys, setTodosKeys] = useState([]);
  const [abiertos, setAbiertos] = useState(0);
  const [dia, setDia] = useState(0);
  const [semana, setSemana] = useState(0);

  const [cargando, setCargando] = useState(true);
  const [ultimaActualizacion, setUltimaActualizacion] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [nuevos, setNuevos] = useState([]);

  const [resumenEstados, setResumenEstados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [ingenieroSeleccionado, setIngenieroSeleccionado] = useState("");
  const [ticketsIngeniero, setTicketsIngeniero] = useState([]);

  const obtenerHoraActual = () => {
    return new Date().toLocaleTimeString("es-MX", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleBarClick = async (data) => {
    if (!data || !data.key) return;

    const nombre = data.key;

    setIngenieroSeleccionado(nombre);
    setShowModal(true);
    setTicketsIngeniero([]);

    try {
      const res = await api.get(
        `/dashboard/tickets-por-ingeniero?ingeniero=${encodeURIComponent(
          nombre
        )}`
      );
      setTicketsIngeniero(res.data);
    } catch (err) {
      console.error("Error cargando tickets del ingeniero", err);
    }
  };

  const cargarDatos = async () => {
    try {
      // 1) Tickets sin asignar
      const resTickets = await api.get("/dashboard/tickets");
      const nuevosDatos = resTickets.data;

      const idsAntiguos = data.map((t) => t.id + "-" + t.descripcion);
      const idsNuevos = nuevosDatos.map((t) => t.id + "-" + t.descripcion);

      const registrosNuevos = idsNuevos.filter(
        (id) => !idsAntiguos.includes(id)
      );

      if (data.length > 0 && registrosNuevos.length > 0) {
        setNuevos(registrosNuevos);
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
        setTimeout(() => setNuevos([]), 3000);
      }

      setData(nuevosDatos);

      // 2) KPI Abiertos
      const resAbiertos = await api.get("/dashboard/abiertos");
      setAbiertos(resAbiertos.data.total);

      // 3) KPI Día
      const resDia = await api.get("/dashboard/dia");
      setDia(resDia.data.total);

      // 4) KPI Semana
      const resSemana = await api.get("/dashboard/semana");
      setSemana(resSemana.data.total);

      // 5) Compras
      const resCompras = await api.get("/dashboard/compras");
      setCompras(resCompras.data);

      // 6) Todos los keys
      const resTodosKeys = await api.get("/dashboard/todos-keys");
      setTodosKeys(resTodosKeys.data);

      // 7) Tickets por ingeniero (actualizado por semana usando updated)
      const resResumen = await api.get("/dashboard/resumen-estados");
      setResumenEstados(resResumen.data);

      setUltimaActualizacion(obtenerHoraActual());
      setCargando(false);
    } catch (error) {
      console.error("Error cargando datos:", error);
    }
  };

  useEffect(() => {
    cargarDatos();
    const intervalo = setInterval(cargarDatos, 20000);
    return () => clearInterval(intervalo);
  }, []);

  if (cargando) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  // Ordenar gráficas
  const comprasOrdenadas = [...compras].sort((a, b) => b.cantidad - a.cantidad);
  const todosKeysOrdenados = [...todosKeys].sort(
    (a, b) => b.cantidad - a.cantidad
  );

  const calcularDias = (fecha) => {
    const hoy = new Date();
    const creada = new Date(fecha);
    const h = new Date();
    h.setHours(0, 0, 0, 0);
    const c = new Date(fecha);
    c.setHours(0, 0, 0, 0);
    const dias = (h - c) / (1000 * 60 * 60 * 24);
    const horaCreacion = new Date(fecha).getHours();
    return horaCreacion >= 17 ? `${dias} ⏱️` : dias;
  };

  return (
    <div className="page-background">
      <div className="container mt-4" style={{ maxWidth: "97%" }}>
        {/* KPIs */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">🎫 Tickets</h3>

          <div className="d-flex gap-4 align-items-center">
            {/* SIN ASIGNAR */}
            <div style={kpiCard("#e7f1ff", "#bcd4ff", "#0d6efd")}>
              <div style={kpiTitle("#0d6efd")}>Sin asignar</div>
              <div style={kpiValue("#0d6efd")}>{data.length}</div>
            </div>

            {/* ABIERTOS */}
            <div style={kpiCard("#e8f6ee", "#b8e5cc", "#198754")}>
              <div style={kpiTitle("#198754")}>Abiertos</div>
              <div style={kpiValue("#198754")}>{abiertos}</div>
            </div>

            {/* DÍA */}
            <div style={kpiCard("#fff3cd", "#ffeaa7", "#e67e22")}>
              <div style={kpiTitle("#e67e22")}>Día</div>
              <div style={kpiValue("#e67e22")}>{dia}</div>
            </div>

            {/* SEMANA */}
            <div style={kpiCard("#ffeaa7", "#fdcb6e", "#d35400")}>
              <div style={kpiTitle("#d35400")}>Semana</div>
              <div style={kpiValue("#d35400")}>{semana}</div>
            </div>
          </div>

          <p className="text-muted mb-0">
            Última actualización: <strong>{ultimaActualizacion}</strong>
          </p>
        </div>

        {showAlert && (
          <Alert variant="success" className="text-center">
            ¡Hay nuevos tickets sin asignar!
          </Alert>
        )}

        <Row>
          {/* IZQUIERDA */}
          <Col md={4}>
            <Table striped bordered hover responsive>
              <thead className="table-header">
                <tr>
                  <th>Días</th>
                  <th>ID</th>
                  <th>Descripción</th>
                </tr>
              </thead>

              <tbody>
                {data.map((fila, index) => {
                  const idUnico = fila.id + "-" + fila.descripcion;
                  const esNuevo = nuevos.includes(idUnico);

                  return (
                    <tr
                      key={index}
                      className={`table-small 
                      ${esNuevo ? "row-nueva" : ""} 
                      ${
                        new Date(fila.created).getTime() <
                        new Date().setHours(0, 0, 0, 0)
                          ? "row-vencido"
                          : ""
                      }
                    `}
                    >
                      <td>{calcularDias(fila.created)}</td>
                      <td>{fila.id.replace("GCSD-", "")}</td>
                      <td>{fila.descripcion}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>

          {/* DERECHA → GRÁFICAS + TABLA INGENIEROS */}
          <Col md={8}>
            {/* Gráficas */}
            <Row>
              <Col md={6}>
                <Card className="mb-3 shadow">
                  <Card.Body style={{ padding: "6px" }}>
                    <h6 className="text-center mb-3">General - Soporte</h6>
                    <div className="chart-container">
                      <ResponsiveContainer>
                        <BarChart
                          data={todosKeysOrdenados}
                          margin={{ top: 20, right: 20, left: 0, bottom: 40 }}
                        >
                          <XAxis
                            dataKey="key"
                            angle={-90}
                            textAnchor="end"
                            interval={0}
                            height={100}
                          />
                          <YAxis />
                          <Tooltip />
                          <Bar
                            dataKey="cantidad"
                            fill="#198754"
                            onClick={handleBarClick}
                            cursor="pointer"
                          >
                            <LabelList dataKey="cantidad" position="top" />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="mb-3 shadow">
                  <Card.Body style={{ padding: "6px" }}>
                    <h6 className="text-center mb-3">Compras - Soporte</h6>
                    <div className="chart-container">
                      <ResponsiveContainer>
                        <BarChart
                          data={comprasOrdenadas}
                          margin={{ top: 20, right: 20, left: 0, bottom: 40 }}
                        >
                          <XAxis
                            dataKey="key"
                            angle={-90}
                            textAnchor="end"
                            interval={0}
                            height={100}
                          />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="cantidad" fill="#0d6efd">
                            <LabelList dataKey="cantidad" position="top" />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* TABLA POR INGENIERO */}
            <Row className="mt-3" style={{ height: "34vh" }}>
              <Col md={12} style={{ height: "100%" }}>
                <Card className="shadow" style={{ height: "100%" }}>
                  <Card.Body style={{ height: "100%", overflowY: "auto" }}>
                    <h6 className="mb-3"></h6>

                    <Table
                      striped
                      bordered
                      hover
                      responsive
                      size="sm"
                      style={{ fontSize: "12px" }}
                    >
                      <thead className="table-header">
                        <tr>
                          <th>Nombre</th>
                          <th>Pendientes</th>
                          <th>En curso</th>
                          <th>Cerrados en la semana</th>
                        </tr>
                      </thead>

                      <tbody>
                        {resumenEstados.map((fila, index) => (
                          <tr key={index}>
                            <td>{fila.nombre}</td>
                            <td>{fila.pendientes}</td>
                            <td>{fila.enCurso}</td>
                            <td>{fila.cerrados}</td>
                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr
                          style={{ background: "#f0f0f0", fontWeight: "bold" }}
                        >
                          <td className="text-end">Totales:</td>
                          <td>
                            {resumenEstados.reduce(
                              (acc, f) => acc + f.pendientes,
                              0
                            )}
                          </td>
                          <td>
                            {resumenEstados.reduce(
                              (acc, f) => acc + f.enCurso,
                              0
                            )}
                          </td>
                          <td>
                            {resumenEstados.reduce(
                              (acc, f) => acc + f.cerrados,
                              0
                            )}
                          </td>
                        </tr>
                      </tfoot>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        dialogClassName="modal-xxl-custom"
      >
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>Tickets de {ingenieroSeleccionado}</Modal.Title>

            <span
              style={{
                fontSize: "12px",
                color: "#6c757d",
                marginRight: "32px", // espacio para que no choque con la X
              }}
            >
              Total: <strong>{ticketsIngeniero.length}</strong>
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div style={{ fontSize: "15px" }}>
            {ticketsIngeniero.length === 0 ? (
              <p className="text-muted text-center">
                No hay tickets para este ingeniero
              </p>
            ) : (
              <Table striped bordered hover responsive size="sm">
                <thead className="table-header">
                  <tr>
                    <th>ID</th>
                    <th className="col-descripcion">Descripción</th>
                    <th>Estado</th>
                    <th>Categoría</th>
                    <th>Creado</th>
                    <th>Última actualización</th>
                    <th>Días</th>
                  </tr>
                </thead>

                <tbody>
                  {[...ticketsIngeniero]
                    .sort((a, b) => {
                      const numA = parseInt(a.id.replace(/\D+/g, ""), 10);
                      const numB = parseInt(b.id.replace(/\D+/g, ""), 10);
                      return numB - numA;
                    })
                    .map((t, index) => (
                      <tr key={index}>
                        <td>{t.id}</td>
                        <td className="col-descripcion">{t.descripcion}</td>
                        <td>{t.status}</td>
                        <td>{t.categoria}</td>
                        <td>{new Date(t.created).toLocaleDateString()}</td>
                        <td>{new Date(t.updated).toLocaleDateString()}</td>
                        <td>{calcularDias(t.created)}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

/* Helpers para estilizar KPIs */
const kpiCard = (bg, border, color) => ({
  background: bg,
  border: `1px solid ${border}`,
  padding: "8px 16px",
  borderRadius: "10px",
  minWidth: "160px",
  textAlign: "center",
});

const kpiTitle = (color) => ({
  fontSize: "16px",
  color,
  fontWeight: "600",
});

const kpiValue = (color) => ({
  fontSize: "34px",
  color,
  fontWeight: "800",
  lineHeight: "1",
});

export default App;
